import { Tree, Bathtub, SwimmingPool, Fire, WifiHigh, Dog, Bicycle, Coffee } from "@phosphor-icons/react";
import Reveal from "@/components/Reveal";
import { AMENITIES } from "@/lib/site";
import { withBoldComingSoon } from "@/lib/textFormat";

const ICONS = { Tree, Bathtub, SwimmingPool, Fire, WifiHigh, Dog, Bicycle, Coffee };

export default function AmenitiesBento() {
  return (
    <section className="bg-sa-bg2/60" data-testid="amenities-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <Reveal className="max-w-2xl mb-16">
          <div className="overline">The park</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight mt-4">
            Everything you need, <em className="italic font-light">nothing you don't.</em>
          </h2>
          <p className="mt-6 text-sa-ink2 text-base sm:text-lg leading-relaxed">
            Twelve acres of mostly shaded sites with grown-up amenities — a seasonal relaxation pool (Dec–April), clean bathrooms and a fire-pit circle for those long blue Ballarat evenings.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] gap-4 md:gap-5">
          {AMENITIES.map((a, idx) => {
            const Icon = ICONS[a.icon] || Tree;
            const isLg = a.size === "lg";
            return (
              <Reveal
                key={a.title}
                delay={idx * 50}
                className={`${isLg ? "col-span-2 row-span-2" : ""} bg-white border border-sa-ink/8 rounded-2xl p-6 md:p-7 flex flex-col justify-between hover:-translate-y-1 transition-transform duration-300`}
              >
                <Icon size={isLg ? 40 : 28} weight="duotone" className="text-sa-accent" />
                <div>
                  <h3 className={`font-serif ${isLg ? "text-2xl" : "text-lg"} tracking-tight`}>{a.title}</h3>
                  <p className="mt-2 text-sa-ink2 text-sm leading-relaxed">{withBoldComingSoon(a.body)}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
